/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class AuthGuard
 */
import { Guard, GuardResult } from 'vue-router-guards';
import store from '@/store';
import { Route } from 'vue-router';

export class AuthGuard implements Guard {
  public async execute(to: Route, _from: Route): Promise<GuardResult> {
    const route = to.matched.find((record) => Object.prototype.hasOwnProperty.call(record.meta, 'requiresAuth'));
    const isAuth = store.getters['app/auth/IsAuth'];

    if (route === undefined) {
      return new GuardResult(true);
    }

    if (!route.meta.requiresAuth) {
      if (isAuth) {
        return new GuardResult(false, '/dashboard/events');
      }
      return new GuardResult(true);
    }

    if (route) {
      if (isAuth) {
        return new GuardResult(true);
      }
      return new GuardResult(false, '/login');
    }

    return new GuardResult(false, '/login');
  }
}
